import React from "react";
import { Context } from "../../context";
import PreParser from "../../preParser";
import PostTemplate from "./post-template";
require("../../../styles/news.scss");
const Query = (props) => {
    const { subQueries } = React.useContext(Context);
    if (!props.attributes.variation) {
        return React.createElement(React.Fragment, null);
    }
    let posts = [];
    const currentPosts = props.latestPost
        ? [props.latestPost]
        : subQueries.find((e) => e.id === props.attributes.queryId)?.posts.nodes ||
            [];
    if (props.attributes.variation === "one-last-news" || !props.allPosts) {
        posts.push(...currentPosts);
    }
    else {
        posts.push(...props.allPosts);
    }
    const className = [
        "news",
        props.attributes.variation,
        props.attributes.displayLayout?.type,
        "columns-" + props.attributes.displayLayout?.columns,
    ];
    if (props.attributes.align) {
        className.push("align" + props.attributes.align);
    }
    const Wrapper = ({ children }) => {
        if (props.attributes.variation === "one-last-news") {
            return (React.createElement("div", { style: props.style, className: "one-last-news" }, children));
        }
        return (React.createElement("section", { style: props.style, className: className.join(" ") }, children));
    };
    const newChildren = props.children ? (React.cloneElement(props.children, {
        ...props.children.props,
        index: props.innerBlocks.findIndex((block) => block.name === "core/query-pagination"),
    })) : (React.createElement(React.Fragment, null));
    return (React.createElement(Wrapper, null,
        React.createElement(PreParser, { structure: props.innerBlocks },
            React.createElement(PostTemplate, { posts: posts }),
            newChildren)));
};
Query._ges_name = "Query";
export default Query;
